module.exports = __webpack_public_path__ + "static/img/Harrison-Delbridge.d4aff2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Harrison-Delbridge.jpg
// module id = d4MI
// module chunks = 0